var _a, _b, _c, _d;
export var Brands;
(function (Brands) {
    Brands["FOX"] = "fox";
    Brands["NATION"] = "nation";
    Brands["FOXNEWS"] = "news";
})(Brands || (Brands = {}));
/**
 * TODO: look into whether strings can be declared without initializers:
 * https://www.typescriptlang.org/docs/handbook/enums.html
 */
export var Events;
(function (Events) {
    Events["ACCOUNT_UPDATE_PASSWORD_LANDING"] = "accountUpdatePasswordLanding";
    Events["ADDED_FAVORITES"] = "addedFavorites";
    Events["AUTHENTICATION_COMPLETED"] = "authenticationCompleted";
    Events["AUTHENTICATION_STARTED"] = "authenticationStarted";
    Events["AUTHENTICATON_SELECT_PROVIDER_COMPLETED"] = "authenticationSelectProviderCompleted";
    Events["AUTHENTICATON_SELECT_PROVIDER_ERROR"] = "authenticationSelectProviderError";
    Events["AUTHENTICATON_SELECT_PROVIDER_STARTED"] = "authenticationSelectProviderStarted";
    Events["AUTHETNTICATION_LOGGED_OUT"] = "AuthenticationLoggedOut";
    Events["BANNER_CLICKED"] = "bannerClicked";
    Events["BANNER_NOTIFICATION_ACTION"] = "bannerNotificationAction";
    Events["BANNER_NOTIFICATION_IMPRESSION"] = "bannerNotificationImpression";
    Events["BROWSE_ITEM_SELECTED"] = "browseItemSelected";
    Events["BUTTON_LINK_SELECTED"] = "buttonLinkSelected";
    Events["CAST_LANDING"] = "castLanding";
    Events["CCPA_PAGE_LANDING"] = "CCPAPageLanding";
    Events["CHANNEL_PAGE_LANDING"] = "channelPageLanding";
    Events["COLLECTION_ITEMS_AVAILABLE"] = "collectionItemsAvailable";
    Events["COLLECTION_ITEMS_RENDERED"] = "collectionItemsRendered";
    Events["CONTINUE_WATCHING_WIDGET"] = "continueWatchingWidget";
    Events["DETAILS_PAGE_PLAYLIST_LANDING"] = "detailsPagePlaylistLanding";
    Events["DETAIL_PAGE_DEFAULT_STATE"] = "detailsPageDefaultState";
    Events["DETAIL_PAGE_MENU_ITEM_VIEW"] = "detailPageMenuItemView";
    Events["EMAIL_ROADBLOCK_IMPRESSION"] = "emailRoadblockImpression";
    Events["EMAIL_ROADBLOCK_SUBMIT"] = "emailRoadblockSubmit";
    Events["EMAIL_ROADBLOCK_BYPASS"] = "emailRoadblockBypass";
    Events["EMAIL_ROADBLOCK_ABANDON"] = "emailRoadblockAbandon";
    Events["END_CARD_ITEM_SELECTED"] = "endCardItemSelected";
    Events["EVENT_END_CARD_IMPRESSION"] = "endCardImpression";
    Events["EXPERIMENT_VIEWED"] = "experimentViewed";
    Events["EXPOSURE"] = "exposure";
    Events["FB_LINKING_COMPLETED"] = "fbLinkingCompleted";
    Events["FB_LINKING_STARTED"] = "fbLinkingStarted";
    Events["FB_PASSWORD_CREATION_COMPLETED"] = "fbPasswordCreationCompleted";
    Events["FB_PASSWORD_CREATION_STARTED"] = "fbPasswordCreationStarted";
    Events["FB_SIGN_IN_COMPLETED"] = "fbSignInCompleted";
    Events["FB_SIGN_IN_STARTED"] = "fbSignInStarted";
    Events["FB_SIGN_UP_COMPLETED"] = "fbSignUpCompleted";
    Events["FB_SIGN_UP_STARTED"] = "fbSignUpStarted";
    Events["FIND_SECTION_SEARCH"] = "findSectionSearch";
    Events["FOOTER_LINK_CLICKED"] = "footerLinkClicked";
    Events["GLOBAL_NAV_CLICKED"] = "globalNavClicked";
    Events["HEADER_LINK_CLICKED"] = "headerLinkClicked";
    Events["HERO_ITEM_SELECT_ACTION"] = "heroItemSelectAction";
    Events["IDLE_PROMPT"] = "idlePrompt";
    Events["IDLE_PROMPT_ACTION"] = "idlePromptAction";
    Events["LIVE_TV_BUTTON_ACTION"] = "liveTvButtonAction";
    Events["LIVE_TV_EPG_CELL_TAPPED"] = "liveTvEpgCellTapped";
    Events["LIVE_TV_EPG_DETAIL_EXPAND"] = "epgDetailExpand";
    Events["LOCAL_SECTION_LANDING"] = "localSectionLanding";
    Events["MENU_ITEM_SELECTED"] = "menuItemSelected";
    Events["MODAL_CLOSED"] = "modalClosed";
    Events["PLAYER_LANDING"] = "playerLanding";
    Events["PLAYER_SCREEN_LAYOUT_CHANGED"] = "Player Screen Layout Changed";
    Events["PLAYLIST_BUTTON_ACTION"] = "playlistButtonAction";
    Events["PREVIEW_PASS_EXPIRED"] = "previewPassExpired";
    Events["PRIVACY_POLICY_PAGE_VIEW"] = "privacyPolicyPageView";
    Events["PRIVIEW_PASS_STARTED"] = "previewPassStarted";
    Events["PROFILE_APPLE_ID_LINK_COMPLETED"] = "profileAppleIdLinkCompleted";
    Events["PROFILE_APPLE_ID_LINK_STARTED"] = "profileAppleIdLinkStarted";
    Events["PROFILE_APPLE_ID_SIGNUP_COMPLETED"] = "profileAppleIdSignUpCompleted";
    Events["PROFILE_APPLE_ID_SIGNUP_STARTED"] = "profileAppleIdSignUpStarted";
    Events["PROFILE_GOOGLE_LINK_COMPLETED"] = "profileGoogleLinkCompleted";
    Events["PROFILE_GOOGLE_LINK_STARTED"] = "profileGoogleLinkStarted";
    Events["PROFILE_INITIATED"] = "profileInitiated";
    Events["PROFILE_LOGGED_OUT"] = "profileLoggedOut";
    Events["PROFILE_PROMPT"] = "profilePrompt";
    Events["PROFILE_PROMPT_LANDING"] = "profilePromptLanding";
    Events["PROFILE_SCREEN_BACKED_OUT"] = "profileScreenBackedOut";
    Events["PROFILE_SIGNIN_COMPLETED"] = "profileSignInCompleted";
    Events["PROFILE_SIGNUP_COMPLETED"] = "profileSignUpCompleted";
    Events["PROFILE_SIGNUP_STATRED"] = "profileSignUpStarted";
    Events["PROFILE_SIGN_IN_ERROR"] = "profileSignInError";
    Events["PROFILE_SIGN_IN_FORGOT_PASSWORD"] = "profileSignInForgotPassword";
    Events["PROFILE_SIGN_IN_LANDING"] = "profileSignInLanding";
    Events["PROFILE_SIGN_IN_STARTED"] = "profileSignInStarted";
    Events["PROFILE_SIGN_OUT"] = "signOutCompleted";
    Events["PROFILE_SIGN_OUT_STARTED"] = "signOutStarted";
    Events["PROFILE_SIGN_UP_ERROR"] = "profileSignupError";
    Events["PROFILE_SIGN_UP_LANDING"] = "profileSignUpLanding";
    Events["PROFILE_UPSELL_PRESENTED"] = "profileUpsellPresented";
    Events["PURCHASE_CTA_CLICKED"] = "purchaseCtaClicked";
    Events["REMOVED_FAVORITES"] = "removedFavorites";
    Events["ROADBLOCK_LANDING"] = "roadblockLanding";
    Events["SEARCH_APPLIED_FILTER"] = "searchAppliedFilter";
    Events["SEARCH_COMPLETED"] = "searchCompleted";
    Events["SEARCH_RESULT_SELECTED"] = "searchResultSelected";
    Events["SEARCH_STARTED"] = "searchStarted";
    Events["SETTINGS_SECTION_LANDING"] = "settingsSectionLanding";
    Events["SHOP_NOW_BUTTON_CLICKED"] = "shopNowButtonClicked";
    Events["TOP_LEVEL_SECTION_LANDING"] = "topLevelSectionLanding";
    Events["UPGRADE_NOW_BUTTON_CLICKED"] = "upgradeNowButtonClicked";
})(Events || (Events = {}));
export var EventTypes;
(function (EventTypes) {
    EventTypes["PAGE"] = "page";
    EventTypes["TRACK"] = "track";
})(EventTypes || (EventTypes = {}));
export var Vendors;
(function (Vendors) {
    Vendors[Vendors["NEW_RELIC"] = 0] = "NEW_RELIC";
    Vendors[Vendors["OPTIMIZELY"] = 1] = "OPTIMIZELY";
    Vendors[Vendors["SEGMENT"] = 2] = "SEGMENT";
    Vendors[Vendors["TEALIUM"] = 3] = "TEALIUM";
})(Vendors || (Vendors = {}));
export var ComscoreClientIds;
(function (ComscoreClientIds) {
    ComscoreClientIds["FOX"] = "6042901";
    ComscoreClientIds["NATION"] = "9013181";
})(ComscoreClientIds || (ComscoreClientIds = {}));
export var CookieValues;
(function (CookieValues) {
    CookieValues["CCPA_DO_NOT_SELL_NOT_SEEN"] = "1---";
    CookieValues["CCPA_DO_NOT_SELL_SEEN"] = "1YNN";
    CookieValues["CCPA_DO_NOT_SELL_CHECKED"] = "1YYN";
})(CookieValues || (CookieValues = {}));
export var LocalStorage;
(function (LocalStorage) {
    LocalStorage["PERCENT_WATCHING"] = "PERCENT_WATCHING";
    LocalStorage["APP_VISITED"] = "APP_VISITED";
    LocalStorage["FP_STATE"] = "FP_STATE";
    LocalStorage["LOGGED_OUT_AUTH"] = "LOGGED_OUT_AUTH";
})(LocalStorage || (LocalStorage = {}));
export var FoxProfileEvents;
(function (FoxProfileEvents) {
    FoxProfileEvents["FP_SIGNED_OUT"] = "signed out";
    FoxProfileEvents["FP_SIGN_IN_ATTEMPTED"] = "sign in attempted";
    FoxProfileEvents["FP_SIGN_IN_COMPLETED"] = "sign in completed";
    FoxProfileEvents["FP_SIGN_OUT_ATTEMPTED"] = "sign out attempted";
    FoxProfileEvents["FP_SIGN_UP_ATTEMPTED"] = "sign up attempted";
    FoxProfileEvents["FP_SIGN_UP_COMPLETED"] = "sign up completed";
})(FoxProfileEvents || (FoxProfileEvents = {}));
export var NewRelicErrors;
(function (NewRelicErrors) {
    NewRelicErrors["apiError"] = "API_ERROR";
    NewRelicErrors["appInitializeError"] = "APP_INIT_ERROR";
    NewRelicErrors["appScreenDrawError"] = "APP_SCREEN_DRAW_ERROR";
    NewRelicErrors["generalError"] = "ERROR";
    NewRelicErrors["videoStartError"] = "VIDEO_START_ERROR";
    NewRelicErrors["videoStreamInterruptedError"] = "VIDEO_STREAM_INTERRUPTED_ERROR";
})(NewRelicErrors || (NewRelicErrors = {}));
export var NewRelicEvents;
(function (NewRelicEvents) {
    NewRelicEvents["onAccountScreenFinished"] = "ACCOUNT_SCREEN_LOADING_FINISH";
    NewRelicEvents["onAccountScreenStart"] = "ACCOUNT_SCREEN_LOADING_START";
    NewRelicEvents["onAccountScreenView"] = "ACCOUNTPAGE_VIEW";
    NewRelicEvents["onAppLoad"] = "LAUNCH";
    NewRelicEvents["onEntertainmentScreenFinished"] = "ENTERTAINMENT_SCREEN_LOADING_FINISH";
    NewRelicEvents["onEntertainmentScreenStart"] = "ENTERTAINMENT_SCREEN_LOADING_START";
    NewRelicEvents["onEntertainmentScreenView"] = "ENTERTAINMENTPAGE_VIEW";
    NewRelicEvents["onHomeScreenFinished"] = "HOME_SCREEN_LOADING_FINISH";
    NewRelicEvents["onHomeScreenStart"] = "HOME_SCREEN_LOADING_START";
    NewRelicEvents["onLiveScreenFinished"] = "LIVE_SCREEN_LOADING_FINISH";
    NewRelicEvents["onLiveScreenStart"] = "LIVE_SCREEN_LOADING_START";
    NewRelicEvents["onLiveScreenView"] = "LIVEPAGE_VIEW";
    NewRelicEvents["onMVPDSignIn"] = "MVPD_SIGN_IN_EVENT";
    NewRelicEvents["onNewsScreenFinished"] = "NEWS_SCREEN_LOADING_FINISH";
    NewRelicEvents["onNewsScreenStart"] = "NEWS_SCREEN_LOADING_START";
    NewRelicEvents["onNewsScreenView"] = "NEWSPAGE_VIEW";
    NewRelicEvents["onProfileSignIn"] = "PROFILE_SIGN_IN_EVENT";
    NewRelicEvents["onProfileSignUp"] = "PROFILE_SIGN_UP_EVENT";
    NewRelicEvents["onSearchScreenFinished"] = "SEARCH_SCREEN_LOADING_FINISH";
    NewRelicEvents["onSearchScreenStart"] = "SEARCH_SCREEN_LOADING_START";
    NewRelicEvents["onSearchScreenView"] = "SEARCHPAGE_VIEW";
    NewRelicEvents["onSportsScreenFinished"] = "SPORTS_SCREEN_LOADING_FINISH";
    NewRelicEvents["onSportsScreenStart"] = "SPORTS_SCREEN_LOADING_START";
    NewRelicEvents["onSportsScreenView"] = "SPORTSPAGE_VIEW";
    NewRelicEvents["onVideoPlaybackStart"] = "VIDEO_PLAYBACK_START";
    NewRelicEvents["onVideoPlayClick"] = "VIDEO_PLAY_CTA_CLICK_EVENT";
})(NewRelicEvents || (NewRelicEvents = {}));
export var OptimizelyPlayerTypes;
(function (OptimizelyPlayerTypes) {
    OptimizelyPlayerTypes["FOX_MINI_PLAYER"] = "fox_mini_player";
    OptimizelyPlayerTypes["MAIN_PLAYER"] = "main_player";
    OptimizelyPlayerTypes["NATIVE_MINI_PLAYER"] = "os_mini_player";
})(OptimizelyPlayerTypes || (OptimizelyPlayerTypes = {}));
/* multi-platform page events */
export var PageEvents;
(function (PageEvents) {
    PageEvents["CCPA_PAGE_LANDING"] = "CCPA Page Landing";
    PageEvents["CC_SERVICE_VIEWED"] = "ccServiceViewed";
    PageEvents["CHANGE_PASSWORD_PAGE_VIEW"] = "changePasswordPageEvent";
    PageEvents["COLLECTION_CTA_PAGE_VIEW"] = "collectionCTAPageViewEvent";
    PageEvents["KNOWN_PROFILE_PAGE_VIEW"] = "knownProfilePageEvent";
    PageEvents["LIVE_LOC_REQ_PAGE_VIEW"] = "liveLocationRequiredPageView";
    PageEvents["PARENTAL_CONTROLS_SETTINGS_PAGE_VIEW"] = "parentalControlsSettingsPageEvent";
    PageEvents["PRIVACY_POLICY_PAGE_VIEW"] = "privacyPolicyPageView";
    PageEvents["TV_PROVIDER_SIGN_OUT_PAGE_VIEW"] = "tvProviderSignOutPageEvent";
})(PageEvents || (PageEvents = {}));
// TODO refactor to be included in handleAnalytics logic
export var PageNames;
(function (PageNames) {
    PageNames["ALL_COLLECTIONS"] = "PAGE_NAME_ALL_COLLECTIONS";
    PageNames["ARTICLE"] = "PAGE_NAME_ARTICLE";
    PageNames["CHANNEL"] = "CHANNEL_PAGE_LANDING";
    PageNames["COLLECTION"] = "PAGE_NAME_COLLECTION";
    PageNames["COLLECTION_ENTERTAINMENT"] = "PAGE_NAME_COLLECTION_ENTERTAINMENT";
    PageNames["COLLECTION_HOME"] = "PAGE_NAME_COLLECTION_HOME";
    PageNames["COLLECTION_LISTEN"] = "PAGE_NAME_COLLECTION_LISTEN";
    PageNames["COLLECTION_LIVE_TV"] = "PAGE_NAME_COLLECTION_LIVE_TV";
    PageNames["COLLECTION_LOCAL"] = "PAGE_NAME_COLLECTION_LOCAL";
    PageNames["COLLECTION_MOVIES"] = "PAGE_NAME_COLLECTION_MOVIES";
    PageNames["COLLECTION_NEWS"] = "PAGE_NAME_COLLECTION_NEWS";
    PageNames["COLLECTION_PERSONALITIES"] = "PAGE_NAME_COLLECTION_PERSONALITIES";
    PageNames["COLLECTION_PRIMETIME"] = "PAGE_NAME_COLLECTION_PRIMETIME";
    PageNames["COLLECTION_SHOWS"] = "PAGE_NAME_COLLECTION_SHOWS";
    PageNames["COLLECTION_SPORTS"] = "PAGE_NAME_COLLECTION_SPORTS";
    PageNames["CONTINUOUS_PLAY"] = "PAGE_NAME_CONTINUOUS_PLAY";
    PageNames["DEEPLINK"] = "PAGE_NAME_DEEPLINK";
    PageNames["DETAIL"] = "PAGE_NAME_DETAIL";
    PageNames["ENDCARD"] = "PAGE_NAME_ENDCARD";
    PageNames["FAVORITES_DETAIL"] = "FAVORITES_PAGE_NAME_DETAIL";
    PageNames["FAVORITES_LIVE"] = "FAVORITES_PAGE_NAME_LIVE";
    PageNames["FIND"] = "PAGE_NAME_FIND";
    PageNames["FOOTER"] = "PAGE_NAME_FOOTER";
    PageNames["FX_CONFIRM_SUB"] = "PAGE_NAME_FX_CONFIRM_SUB";
    PageNames["FX_MARKETING"] = "PAGE_NAME_FX_MARKETING";
    PageNames["FX_MVPD_NO_SUPPORT"] = "PAGE_NAME_FX_MVPD_NO_SUPPORT";
    PageNames["HOME"] = "PAGE_NAME_HOME";
    PageNames["HOME_COLLECTIONS"] = "PAGE_NAME_HOME_COLLECTIONS";
    PageNames["LIVE"] = "PAGE_NAME_LIVE";
    PageNames["LIVE_SCHEDULE"] = "PAGE_NAME_LIVE_SCHEDULE";
    PageNames["MOVIE_DETAIL"] = "PAGE_NAME_MOVIE_DETAIL";
    PageNames["MOVIES"] = "PAGE_NAME_MOVIES";
    PageNames["NETWORK_DETAIL"] = "PAGE_NAME_NETWORK_DETAIL";
    PageNames["NEWS"] = "PAGE_NAME_NEWS";
    PageNames["PLAYER"] = "PAGE_NAME_PLAYER";
    PageNames["PLAYER_COLLECTION"] = "PAGE_NAME_PLAYER_COLLECTION";
    PageNames["PLAYER_DETAIL"] = "PAGE_NAME_PLAYER_DETAIL";
    PageNames["PLAYER_GENERAL"] = "PAGE_NAME_PLAYER_GENERAL";
    PageNames["PROFILE_SIGN_IN"] = "PAGE_NAME_PROFILE_SIGN_IN";
    PageNames["PROFILE_SIGN_UP"] = "PAGE_NAME_PROFILE_SIGN_UP";
    PageNames["PROMO_LIST"] = "PAGE_NAME_PROMO_LIST";
    PageNames["SEARCH"] = "PAGE_NAME_SEARCH";
    PageNames["SERIES_DETAIL"] = "PAGE_NAME_SERIES_DETAIL";
    PageNames["SETTINGS"] = "PAGE_NAME_SETTINGS";
    PageNames["SHOWS"] = "PAGE_NAME_SHOWS";
    PageNames["SIGN_IN"] = "PAGE_NAME_SIGN_IN";
    PageNames["VOD_SECTION"] = "PAGE_NAME_VOD_SECTION";
})(PageNames || (PageNames = {}));
export var SegmentActionLocations;
(function (SegmentActionLocations) {
    SegmentActionLocations["DETAIL"] = "Detail";
    SegmentActionLocations["PLAYER"] = "Player";
})(SegmentActionLocations || (SegmentActionLocations = {}));
export var SegmentBannerTypes;
(function (SegmentBannerTypes) {
    SegmentBannerTypes["FAT"] = "fat banner";
    SegmentBannerTypes["SKINNY"] = "skinny banner";
    SegmentBannerTypes["MARKETING_VIDEO"] = "marketing video banner";
})(SegmentBannerTypes || (SegmentBannerTypes = {}));
export var SegmentEventTypes;
(function (SegmentEventTypes) {
    SegmentEventTypes["PAGE_EVENT"] = "page";
    SegmentEventTypes["TRACK_EVENT"] = "track";
})(SegmentEventTypes || (SegmentEventTypes = {}));
export var SegmentPageActionTypes;
(function (SegmentPageActionTypes) {
    SegmentPageActionTypes["MORE_EPISODES"] = "More Episodes";
    SegmentPageActionTypes["SEARCH"] = "Search";
    SegmentPageActionTypes["WATCH"] = "Watch";
    SegmentPageActionTypes["WATCHLIST"] = "Watchlist";
})(SegmentPageActionTypes || (SegmentPageActionTypes = {}));
export var SegmentPageProfileTypes;
(function (SegmentPageProfileTypes) {
    SegmentPageProfileTypes["FACEBOOK"] = "facebook";
    SegmentPageProfileTypes["APPLE"] = "apple";
    SegmentPageProfileTypes["GOOGLE"] = "google";
    SegmentPageProfileTypes["GENERAL"] = "general";
})(SegmentPageProfileTypes || (SegmentPageProfileTypes = {}));
export var SegmentPageStartSources;
(function (SegmentPageStartSources) {
    SegmentPageStartSources["GENERAL"] = "general";
    SegmentPageStartSources["MVPDINCOMPLETE"] = "mvpd incomplete";
    SegmentPageStartSources["ONBOARDING"] = "oboarding";
    SegmentPageStartSources["PP_EXPIRATION"] = "preview pass:expiration";
    SegmentPageStartSources["PP_SIGNIN"] = "upsell";
    SegmentPageStartSources["SETTINGS"] = "settings";
})(SegmentPageStartSources || (SegmentPageStartSources = {}));
export var SegmentPlayerContextStrings;
(function (SegmentPlayerContextStrings) {
    SegmentPlayerContextStrings["RESUMED_PLAYBACK"] = "context.segment.player.resumedPlayback";
    SegmentPlayerContextStrings["RESTARTED_PLAYBACK"] = "context.segment.player.restartedPlayback";
})(SegmentPlayerContextStrings || (SegmentPlayerContextStrings = {}));
export var SegmentPlayerStates;
(function (SegmentPlayerStates) {
    SegmentPlayerStates["BUFFER"] = "buffer";
    SegmentPlayerStates["END"] = "end";
    SegmentPlayerStates["PAUSE"] = "pause";
    SegmentPlayerStates["PLAY"] = "play";
    SegmentPlayerStates["RESUME"] = "resume";
    SegmentPlayerStates["SEEK"] = "seek";
    SegmentPlayerStates["START"] = "start";
})(SegmentPlayerStates || (SegmentPlayerStates = {}));
export var SegmentProfileIdCookies;
(function (SegmentProfileIdCookies) {
    SegmentProfileIdCookies["LAST_KNOWN"] = "lastKnownProfileId";
    SegmentProfileIdCookies["LAST_KNOWN_ANONYMOUS"] = "lastKnownAnonymousProfileId";
})(SegmentProfileIdCookies || (SegmentProfileIdCookies = {}));
export var SegmentReferrerProps;
(function (SegmentReferrerProps) {
    SegmentReferrerProps["TYPE"] = "Referrer Type";
    SegmentReferrerProps["NAME"] = "Referrer Name";
    SegmentReferrerProps["POSITION"] = "Referrer Position";
    SegmentReferrerProps["NONE"] = "None";
})(SegmentReferrerProps || (SegmentReferrerProps = {}));
export var SegmentSources;
(function (SegmentSources) {
    SegmentSources["HOME"] = "Collection";
    SegmentSources["DETAIL"] = "Detail Page";
    SegmentSources["LIVE"] = "Live TV";
    SegmentSources["AUTOPLAY"] = "Continuous Play";
    SegmentSources["DEEPLINK"] = "Deeplink";
    SegmentSources["END_SLATE"] = "End Slate";
    SegmentSources["MY_ACCOUNT"] = "My Account";
    SegmentSources["VOD"] = "Video Player";
    SegmentSources["VOD_SECTION"] = "VOD Player";
})(SegmentSources || (SegmentSources = {}));
export var SegmentUiElements;
(function (SegmentUiElements) {
    SegmentUiElements["INFO"] = "info_icon";
    SegmentUiElements["MORE_EPISODES"] = "more_episodes_link";
    SegmentUiElements["PLAY"] = "play_icon";
    SegmentUiElements["PLUS"] = "plus_icon";
    SegmentUiElements["SERIES_EPISODE"] = "series_episode_link";
    SegmentUiElements["SERIES_TITLE"] = "series_title_link";
})(SegmentUiElements || (SegmentUiElements = {}));
// TODO refactor to SegmentEventStrings
export var SegmentVideoEventStrings;
(function (SegmentVideoEventStrings) {
    SegmentVideoEventStrings["videoStart"] = "Video Started";
    SegmentVideoEventStrings["videoViewed"] = "Video Viewed";
    SegmentVideoEventStrings["videoPlaybackStart"] = "Video Playback Started";
    SegmentVideoEventStrings["videoPlaybackComplete"] = "Video Playback Completed";
    SegmentVideoEventStrings["videoPlaybackBufferStarted"] = "Video Playback Buffer Started";
    SegmentVideoEventStrings["videoPlaybackInterrupted"] = "Video Playback Interrupted";
    SegmentVideoEventStrings["videoContentStart"] = "Video Content Started";
    SegmentVideoEventStrings["videoContentComplete"] = "Video Content Completed";
    SegmentVideoEventStrings["videoContentPlaying"] = "Video Content Playing";
    SegmentVideoEventStrings["videoPlaybackBufferComplete"] = "Video Playback Buffer Completed";
    SegmentVideoEventStrings["videoPlaybackSeekStarted"] = "Video Playback Seek Started";
    SegmentVideoEventStrings["videoPlaybackSeekCompleted"] = "Video Playback Seek Completed";
    SegmentVideoEventStrings["videoPlaybackPaused"] = "Video Playback Paused";
    SegmentVideoEventStrings["videoPlaybackResumed"] = "Video Playback Resumed";
    SegmentVideoEventStrings["videoAdPlaying"] = "Video Ad Playing";
    SegmentVideoEventStrings["videoAdSkipped"] = "Video Ad Skipped";
    SegmentVideoEventStrings["videoAdStarted"] = "Video Ad Started";
    SegmentVideoEventStrings["videoAdCompleted"] = "Video Ad Completed";
    SegmentVideoEventStrings["videoAdPodStarted"] = "Video Ad Break Started";
    SegmentVideoEventStrings["videoAdPodCompleted"] = "Video Ad Break Completed";
    SegmentVideoEventStrings["videoAdResumed"] = "Video Ad Resumed";
    SegmentVideoEventStrings["videoAdBufferStarted"] = "Video Ad Buffer Started";
    SegmentVideoEventStrings["videoSlateStarted"] = "Video Slate Started";
    SegmentVideoEventStrings["videoSlatePlaying"] = "Video Slate Playing";
    SegmentVideoEventStrings["videoSlateCompleted"] = "Video Slate Completed";
    SegmentVideoEventStrings["videoNielsenTagDetected"] = "Nielsen ID3 Tag Detected";
})(SegmentVideoEventStrings || (SegmentVideoEventStrings = {}));
export var TealiumEventPrefixes;
(function (TealiumEventPrefixes) {
    TealiumEventPrefixes["PAGE"] = "analytics_pv_";
    TealiumEventPrefixes["TRACK"] = "analytics_ev_";
})(TealiumEventPrefixes || (TealiumEventPrefixes = {}));
export var TealiumOnboardingActions;
(function (TealiumOnboardingActions) {
    TealiumOnboardingActions["SKIP"] = "skip";
    TealiumOnboardingActions["COMPLETE"] = "complete";
})(TealiumOnboardingActions || (TealiumOnboardingActions = {}));
export var TealiumRedesignEvents;
(function (TealiumRedesignEvents) {
    TealiumRedesignEvents["COLLECTION_IMPRESSION"] = "collectionImpression";
    TealiumRedesignEvents["COLLECTION_ITEM_SELECT"] = "collectionItemSelect";
    TealiumRedesignEvents["HERO_ITEM_SELECT"] = "heroItemSelect";
})(TealiumRedesignEvents || (TealiumRedesignEvents = {}));
export var OptimizelyNotificationTypes;
(function (OptimizelyNotificationTypes) {
    OptimizelyNotificationTypes["ACTIVATE"] = "ACTIVATE:experiment, user_id,attributes, variation, event";
    OptimizelyNotificationTypes["DECISION"] = "DECISION:type, userId, attributes, decisionInfo";
    OptimizelyNotificationTypes["OPTIMIZELY_CONFIG_UPDATE"] = "OPTIMIZELY_CONFIG_UPDATE";
    OptimizelyNotificationTypes["TRACK"] = "TRACK:event_key, user_id, attributes, event_tags, event";
})(OptimizelyNotificationTypes || (OptimizelyNotificationTypes = {}));
export var OptimizelyUserAttributes;
(function (OptimizelyUserAttributes) {
    OptimizelyUserAttributes["APP_SECTION_VISITED"] = "app_section_visited";
    OptimizelyUserAttributes["COLLECTION_VISITED"] = "collection_visited";
    OptimizelyUserAttributes["CURRENT_PAGE_URL"] = "current_page_url";
    OptimizelyUserAttributes["AUTH_STATE"] = "authentication_state";
    OptimizelyUserAttributes["FOX_PROFILE_STATE"] = "fox_profile_state";
    OptimizelyUserAttributes["FIRST_SITE_VISIT"] = "is_first_visit";
    OptimizelyUserAttributes["NUM_VISITS"] = "num_visits";
    OptimizelyUserAttributes["VIDEO_50_PERCENT_WATCHING"] = "50_percent_watching";
})(OptimizelyUserAttributes || (OptimizelyUserAttributes = {}));
export var OptimizelyAuthState;
(function (OptimizelyAuthState) {
    OptimizelyAuthState["NOT_AUTHED"] = "never attempted";
    OptimizelyAuthState["ATTEMPTED_AUTH"] = "authentication attempted";
    OptimizelyAuthState["SUCCESS_AUTH"] = "authentication successful";
    OptimizelyAuthState["SIGN_OUT_ATTEMPTED_AUTH"] = "sign out attempted";
    OptimizelyAuthState["SIGN_OUT_SUCCESS_AUTH"] = "manually signed out";
    OptimizelyAuthState["AUTH_EXPIRED"] = "automatically signed out";
})(OptimizelyAuthState || (OptimizelyAuthState = {}));
/* multi-platform track events */
export var TrackEvents;
(function (TrackEvents) {
    TrackEvents["AUTHENTICATION_STARTED"] = "authenticationStarted";
    TrackEvents["AUTH_SUCCESS_EVENT"] = "authSuccess";
    TrackEvents["FB_LINKING_COMPLETED"] = "fbLinkingCompleted";
    TrackEvents["FB_LINKING_STARTED"] = "fbLinkingStarted";
    TrackEvents["FB_PASSWORD_CREATION_COMPLETED"] = "fbPasswordCreationCompleted";
    TrackEvents["FB_PASSWORD_CREATION_STARTED"] = "fbPasswordCreationStarted";
    TrackEvents["FB_SIGN_IN_COMPLETED"] = "fbSignInCompleted";
    TrackEvents["FB_SIGN_IN_STARTED"] = "fbSignInStarted";
    TrackEvents["FB_SIGN_UP_COMPLETED"] = "fbSignUpCompleted";
    TrackEvents["FB_SIGN_UP_STARTED"] = "fbSignUpStarted";
    TrackEvents["FXPL_PROFILE_SIGN_OUT_COMPLETED"] = "fxplProfileSignOutCompleted";
    TrackEvents["FXPL_PROFILE_SIGN_OUT_SOURCE"] = "fxplProfileSignOutSource";
    TrackEvents["ONBOARDING_START"] = "onboardingStart";
    TrackEvents["ON_FAVORITE"] = "onFavorite";
    TrackEvents["ON_UNFAVORITE"] = "onUnfavorite";
    TrackEvents["PERKS_PRESENTED"] = "perksPresented";
    TrackEvents["PLAYER_IDLE_PROMPT"] = "playerIdlePrompt";
    TrackEvents["PLAYER_IDLE_PROMPT_CONFIRM"] = "playerIdlePromptConfirm";
    TrackEvents["PREVIEW_PASS_EXPIRED"] = "previewPassExpired";
    TrackEvents["PREVIEW_PASS_STARTED"] = "previewPassStarted";
    TrackEvents["PROFILE_MARKETING_OPT_IN_CHANGED"] = "marketingOptInChangedEvent";
    TrackEvents["PROFILE_SCREEN_BACKED_OUT"] = "profileScreenBackedOut";
    TrackEvents["PROFILE_UPSELL_PRESENTED"] = "profileUpsellPresented";
    TrackEvents["SCHEDULE_RESTART"] = "scheduleRestart";
    TrackEvents["SCHEDULE_WATCH_LIVE"] = "scheduleWatchLive";
    TrackEvents["SIGN_IN_COMPLETED"] = "signInCompleted";
    TrackEvents["SIGN_IN_ERROR"] = "signInError";
    TrackEvents["SIGN_IN_FORGOT_PASSWORD_STARTED"] = "signInForgotPasswordStarted";
    TrackEvents["SIGN_IN_INCOMPLETE"] = "signInIncomplete";
    TrackEvents["SIGN_IN_STARTED"] = "signInStarted";
    TrackEvents["SIGN_OUT_COMPLETED"] = "signOutCompleted";
    TrackEvents["SIGN_OUT_STARTED"] = "signOutStarted";
    TrackEvents["SIGN_UP_COMPLETED"] = "signUpCompleted";
    TrackEvents["SIGN_UP_ERROR"] = "signUpError";
    TrackEvents["SIGN_UP_INCOMPLETE"] = "signUpIncomplete";
    TrackEvents["SIGN_UP_STARTED"] = "signUpStarted";
    TrackEvents["TV_PROVIDER_FEAT_LIST"] = "tvProviderFeatListViewed";
})(TrackEvents || (TrackEvents = {}));
export var EventVendorMap = (_a = {},
    _a[Events.ACCOUNT_UPDATE_PASSWORD_LANDING] = [Vendors.SEGMENT],
    _a[Events.ADDED_FAVORITES] = [Vendors.SEGMENT],
    _a[Events.AUTHENTICATION_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.AUTHENTICATION_STARTED] = [Vendors.SEGMENT],
    _a[Events.AUTHENTICATON_SELECT_PROVIDER_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.AUTHENTICATON_SELECT_PROVIDER_ERROR] = [Vendors.SEGMENT],
    _a[Events.AUTHENTICATON_SELECT_PROVIDER_STARTED] = [Vendors.SEGMENT],
    _a[Events.AUTHETNTICATION_LOGGED_OUT] = [Vendors.SEGMENT],
    _a[Events.BANNER_CLICKED] = [Vendors.SEGMENT],
    _a[Events.BANNER_NOTIFICATION_ACTION] = [Vendors.SEGMENT],
    _a[Events.BANNER_NOTIFICATION_IMPRESSION] = [Vendors.SEGMENT],
    _a[Events.BROWSE_ITEM_SELECTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.BUTTON_LINK_SELECTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.CAST_LANDING] = [Vendors.SEGMENT],
    _a[Events.CCPA_PAGE_LANDING] = [Vendors.SEGMENT],
    _a[Events.CHANNEL_PAGE_LANDING] = [Vendors.SEGMENT],
    _a[Events.COLLECTION_ITEMS_AVAILABLE] = [Vendors.SEGMENT],
    _a[Events.COLLECTION_ITEMS_RENDERED] = [Vendors.SEGMENT],
    _a[Events.CONTINUE_WATCHING_WIDGET] = [Vendors.SEGMENT],
    _a[Events.DETAILS_PAGE_PLAYLIST_LANDING] = [Vendors.SEGMENT],
    _a[Events.DETAIL_PAGE_DEFAULT_STATE] = [Vendors.SEGMENT],
    _a[Events.DETAIL_PAGE_MENU_ITEM_VIEW] = [Vendors.SEGMENT],
    _a[Events.EMAIL_ROADBLOCK_IMPRESSION] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.EMAIL_ROADBLOCK_SUBMIT] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.EMAIL_ROADBLOCK_BYPASS] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.EMAIL_ROADBLOCK_ABANDON] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.END_CARD_ITEM_SELECTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.EVENT_END_CARD_IMPRESSION] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.EXPERIMENT_VIEWED] = [Vendors.SEGMENT],
    _a[Events.EXPOSURE] = [Vendors.SEGMENT],
    _a[Events.FB_LINKING_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.FB_LINKING_STARTED] = [Vendors.SEGMENT],
    _a[Events.FB_PASSWORD_CREATION_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.FB_PASSWORD_CREATION_STARTED] = [Vendors.SEGMENT],
    _a[Events.FB_SIGN_IN_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.FB_SIGN_IN_STARTED] = [Vendors.SEGMENT],
    _a[Events.FB_SIGN_UP_COMPLETED] = [Vendors.SEGMENT],
    _a[Events.FB_SIGN_UP_STARTED] = [Vendors.SEGMENT],
    _a[Events.FIND_SECTION_SEARCH] = [Vendors.SEGMENT],
    _a[Events.FOOTER_LINK_CLICKED] = [Vendors.SEGMENT],
    _a[Events.GLOBAL_NAV_CLICKED] = [Vendors.SEGMENT],
    _a[Events.HEADER_LINK_CLICKED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.HERO_ITEM_SELECT_ACTION] = [Vendors.SEGMENT],
    _a[Events.IDLE_PROMPT] = [Vendors.SEGMENT],
    _a[Events.IDLE_PROMPT_ACTION] = [Vendors.SEGMENT],
    _a[Events.LIVE_TV_BUTTON_ACTION] = [Vendors.SEGMENT],
    _a[Events.LIVE_TV_EPG_CELL_TAPPED] = [Vendors.SEGMENT],
    _a[Events.LIVE_TV_EPG_DETAIL_EXPAND] = [Vendors.SEGMENT],
    _a[Events.LOCAL_SECTION_LANDING] = [Vendors.SEGMENT],
    _a[Events.MENU_ITEM_SELECTED] = [Vendors.SEGMENT],
    _a[Events.MODAL_CLOSED] = [Vendors.SEGMENT],
    _a[Events.PLAYER_LANDING] = [Vendors.SEGMENT],
    _a[Events.PLAYER_SCREEN_LAYOUT_CHANGED] = [Vendors.OPTIMIZELY],
    _a[Events.PLAYLIST_BUTTON_ACTION] = [Vendors.SEGMENT],
    _a[Events.PREVIEW_PASS_EXPIRED] = [Vendors.SEGMENT],
    _a[Events.PRIVACY_POLICY_PAGE_VIEW] = [Vendors.SEGMENT],
    _a[Events.PRIVIEW_PASS_STARTED] = [Vendors.SEGMENT],
    _a[Events.PROFILE_APPLE_ID_LINK_COMPLETED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_APPLE_ID_LINK_STARTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_APPLE_ID_SIGNUP_COMPLETED] = [
        Vendors.SEGMENT,
        Vendors.TEALIUM,
    ],
    _a[Events.PROFILE_APPLE_ID_SIGNUP_STARTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_GOOGLE_LINK_COMPLETED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_GOOGLE_LINK_STARTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_INITIATED] = [Vendors.SEGMENT],
    _a[Events.PROFILE_LOGGED_OUT] = [Vendors.SEGMENT],
    _a[Events.PROFILE_PROMPT] = [Vendors.SEGMENT],
    _a[Events.PROFILE_PROMPT_LANDING] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SCREEN_BACKED_OUT] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGNIN_COMPLETED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_SIGNUP_COMPLETED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.PROFILE_SIGNUP_STATRED] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_IN_ERROR] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_IN_FORGOT_PASSWORD] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_IN_LANDING] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_IN_STARTED] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_OUT] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_OUT_STARTED] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_UP_ERROR] = [Vendors.SEGMENT],
    _a[Events.PROFILE_SIGN_UP_LANDING] = [Vendors.SEGMENT],
    _a[Events.PROFILE_UPSELL_PRESENTED] = [Vendors.SEGMENT],
    _a[Events.PURCHASE_CTA_CLICKED] = [Vendors.SEGMENT],
    _a[Events.REMOVED_FAVORITES] = [Vendors.SEGMENT],
    _a[Events.ROADBLOCK_LANDING] = [Vendors.SEGMENT],
    _a[Events.SEARCH_APPLIED_FILTER] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.SEARCH_COMPLETED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.SEARCH_RESULT_SELECTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.SEARCH_STARTED] = [Vendors.SEGMENT, Vendors.TEALIUM],
    _a[Events.SETTINGS_SECTION_LANDING] = [Vendors.SEGMENT],
    _a[Events.SHOP_NOW_BUTTON_CLICKED] = [Vendors.SEGMENT],
    _a[Events.TOP_LEVEL_SECTION_LANDING] = [Vendors.SEGMENT],
    _a[Events.UPGRADE_NOW_BUTTON_CLICKED] = [Vendors.SEGMENT],
    _a);
export var EventTypeMap = (_b = {},
    _b[Events.ACCOUNT_UPDATE_PASSWORD_LANDING] = EventTypes.PAGE,
    _b[Events.ADDED_FAVORITES] = EventTypes.TRACK,
    _b[Events.AUTHENTICATION_COMPLETED] = EventTypes.TRACK,
    _b[Events.AUTHENTICATION_STARTED] = EventTypes.TRACK,
    _b[Events.AUTHENTICATON_SELECT_PROVIDER_COMPLETED] = EventTypes.TRACK,
    _b[Events.AUTHENTICATON_SELECT_PROVIDER_ERROR] = EventTypes.TRACK,
    _b[Events.AUTHENTICATON_SELECT_PROVIDER_STARTED] = EventTypes.TRACK,
    _b[Events.AUTHETNTICATION_LOGGED_OUT] = EventTypes.TRACK,
    _b[Events.BANNER_CLICKED] = EventTypes.TRACK,
    _b[Events.BANNER_NOTIFICATION_ACTION] = EventTypes.TRACK,
    _b[Events.BANNER_NOTIFICATION_IMPRESSION] = EventTypes.TRACK,
    _b[Events.BROWSE_ITEM_SELECTED] = EventTypes.TRACK,
    _b[Events.BUTTON_LINK_SELECTED] = EventTypes.TRACK,
    _b[Events.CAST_LANDING] = EventTypes.PAGE,
    _b[Events.CCPA_PAGE_LANDING] = EventTypes.PAGE,
    _b[Events.CHANNEL_PAGE_LANDING] = EventTypes.PAGE,
    _b[Events.COLLECTION_ITEMS_AVAILABLE] = EventTypes.TRACK,
    _b[Events.COLLECTION_ITEMS_RENDERED] = EventTypes.TRACK,
    _b[Events.CONTINUE_WATCHING_WIDGET] = EventTypes.TRACK,
    _b[Events.DETAILS_PAGE_PLAYLIST_LANDING] = EventTypes.PAGE,
    _b[Events.DETAIL_PAGE_DEFAULT_STATE] = EventTypes.PAGE,
    _b[Events.DETAIL_PAGE_MENU_ITEM_VIEW] = EventTypes.PAGE,
    _b[Events.EMAIL_ROADBLOCK_IMPRESSION] = EventTypes.TRACK,
    _b[Events.EMAIL_ROADBLOCK_SUBMIT] = EventTypes.TRACK,
    _b[Events.EMAIL_ROADBLOCK_BYPASS] = EventTypes.TRACK,
    _b[Events.EMAIL_ROADBLOCK_ABANDON] = EventTypes.TRACK,
    _b[Events.END_CARD_ITEM_SELECTED] = EventTypes.TRACK,
    _b[Events.EVENT_END_CARD_IMPRESSION] = EventTypes.TRACK,
    _b[Events.EXPERIMENT_VIEWED] = EventTypes.TRACK,
    _b[Events.EXPOSURE] = EventTypes.TRACK,
    _b[Events.FB_LINKING_COMPLETED] = EventTypes.TRACK,
    _b[Events.FB_LINKING_STARTED] = EventTypes.TRACK,
    _b[Events.FB_PASSWORD_CREATION_COMPLETED] = EventTypes.TRACK,
    _b[Events.FB_PASSWORD_CREATION_STARTED] = EventTypes.TRACK,
    _b[Events.FB_SIGN_IN_COMPLETED] = EventTypes.TRACK,
    _b[Events.FB_SIGN_IN_STARTED] = EventTypes.TRACK,
    _b[Events.FB_SIGN_UP_COMPLETED] = EventTypes.TRACK,
    _b[Events.FB_SIGN_UP_STARTED] = EventTypes.TRACK,
    _b[Events.FIND_SECTION_SEARCH] = EventTypes.PAGE,
    _b[Events.FOOTER_LINK_CLICKED] = EventTypes.TRACK,
    _b[Events.GLOBAL_NAV_CLICKED] = EventTypes.TRACK,
    _b[Events.HEADER_LINK_CLICKED] = EventTypes.TRACK,
    _b[Events.HERO_ITEM_SELECT_ACTION] = EventTypes.TRACK,
    _b[Events.IDLE_PROMPT] = EventTypes.TRACK,
    _b[Events.IDLE_PROMPT_ACTION] = EventTypes.TRACK,
    _b[Events.LIVE_TV_BUTTON_ACTION] = EventTypes.TRACK,
    _b[Events.LIVE_TV_EPG_CELL_TAPPED] = EventTypes.TRACK,
    _b[Events.LIVE_TV_EPG_DETAIL_EXPAND] = EventTypes.TRACK,
    _b[Events.LOCAL_SECTION_LANDING] = EventTypes.PAGE,
    _b[Events.MENU_ITEM_SELECTED] = EventTypes.TRACK,
    _b[Events.MODAL_CLOSED] = EventTypes.TRACK,
    _b[Events.PLAYER_LANDING] = EventTypes.PAGE,
    _b[Events.PLAYER_SCREEN_LAYOUT_CHANGED] = EventTypes.TRACK,
    _b[Events.PLAYLIST_BUTTON_ACTION] = EventTypes.TRACK,
    _b[Events.PREVIEW_PASS_EXPIRED] = EventTypes.TRACK,
    _b[Events.PRIVACY_POLICY_PAGE_VIEW] = EventTypes.TRACK,
    _b[Events.PRIVIEW_PASS_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_APPLE_ID_LINK_COMPLETED] = EventTypes.TRACK,
    _b[Events.PROFILE_APPLE_ID_LINK_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_APPLE_ID_SIGNUP_COMPLETED] = EventTypes.TRACK,
    _b[Events.PROFILE_APPLE_ID_SIGNUP_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_GOOGLE_LINK_COMPLETED] = EventTypes.TRACK,
    _b[Events.PROFILE_GOOGLE_LINK_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_INITIATED] = EventTypes.TRACK,
    _b[Events.PROFILE_LOGGED_OUT] = EventTypes.TRACK,
    _b[Events.PROFILE_PROMPT] = EventTypes.TRACK,
    _b[Events.PROFILE_PROMPT_LANDING] = EventTypes.PAGE,
    _b[Events.PROFILE_SCREEN_BACKED_OUT] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGNIN_COMPLETED] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGNUP_COMPLETED] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGNUP_STATRED] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_IN_ERROR] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_IN_FORGOT_PASSWORD] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_IN_LANDING] = EventTypes.PAGE,
    _b[Events.PROFILE_SIGN_IN_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_OUT] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_OUT_STARTED] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_UP_ERROR] = EventTypes.TRACK,
    _b[Events.PROFILE_SIGN_UP_LANDING] = EventTypes.PAGE,
    _b[Events.PROFILE_UPSELL_PRESENTED] = EventTypes.TRACK,
    _b[Events.PURCHASE_CTA_CLICKED] = EventTypes.TRACK,
    _b[Events.REMOVED_FAVORITES] = EventTypes.TRACK,
    _b[Events.ROADBLOCK_LANDING] = EventTypes.TRACK,
    _b[Events.SEARCH_APPLIED_FILTER] = EventTypes.TRACK,
    _b[Events.SEARCH_COMPLETED] = EventTypes.TRACK,
    _b[Events.SEARCH_RESULT_SELECTED] = EventTypes.TRACK,
    _b[Events.SEARCH_STARTED] = EventTypes.TRACK,
    _b[Events.SETTINGS_SECTION_LANDING] = EventTypes.PAGE,
    _b[Events.SETTINGS_SECTION_LANDING] = EventTypes.PAGE,
    _b[Events.SHOP_NOW_BUTTON_CLICKED] = EventTypes.TRACK,
    _b[Events.TOP_LEVEL_SECTION_LANDING] = EventTypes.PAGE,
    _b[Events.UPGRADE_NOW_BUTTON_CLICKED] = EventTypes.TRACK,
    _b);
// TODO: add logic that can build these strings for
// both Segment and Tealium from a generic set of strings
export var SegmentEventStrings = (_c = {},
    _c[Events.ACCOUNT_UPDATE_PASSWORD_LANDING] = "Account Update Password Landing",
    _c[Events.ADDED_FAVORITES] = "Added Favorites",
    _c[Events.AUTHENTICATION_COMPLETED] = "Authentication Completed",
    _c[Events.AUTHENTICATION_STARTED] = "Authentication Started",
    _c[Events.AUTHENTICATON_SELECT_PROVIDER_COMPLETED] = "Authentication Select Provider Completed",
    _c[Events.AUTHENTICATON_SELECT_PROVIDER_ERROR] = "Authentication Select Provider Error",
    _c[Events.AUTHENTICATON_SELECT_PROVIDER_STARTED] = "Authentication Select Provider Started",
    _c[Events.AUTHETNTICATION_LOGGED_OUT] = "Authentication Logged Out",
    _c[Events.BANNER_CLICKED] = "Banner Clicked",
    _c[Events.BANNER_NOTIFICATION_ACTION] = "Banner Notification Action",
    _c[Events.BANNER_NOTIFICATION_IMPRESSION] = "Banner Notification Impression",
    _c[Events.BROWSE_ITEM_SELECTED] = "Browse Item Selected",
    _c[Events.BUTTON_LINK_SELECTED] = "Button Link Selected",
    _c[Events.CAST_LANDING] = "Cast Landing",
    _c[Events.CCPA_PAGE_LANDING] = "CCPA Page Landing",
    _c[Events.CHANNEL_PAGE_LANDING] = "Channel Page Landing",
    _c[Events.COLLECTION_ITEMS_AVAILABLE] = "Collection Items Available",
    _c[Events.COLLECTION_ITEMS_RENDERED] = "Collection Items Rendered",
    _c[Events.CONTINUE_WATCHING_WIDGET] = "Continue Watching Widget",
    _c[Events.DETAILS_PAGE_PLAYLIST_LANDING] = "Playlist Landing",
    _c[Events.DETAIL_PAGE_DEFAULT_STATE] = "Details Page Default State",
    _c[Events.DETAIL_PAGE_MENU_ITEM_VIEW] = "Detail Page Menu Item",
    _c[Events.EMAIL_ROADBLOCK_IMPRESSION] = "Email Roadblock Impression",
    _c[Events.EMAIL_ROADBLOCK_SUBMIT] = "Email Roadblock Successful Email Submission",
    _c[Events.EMAIL_ROADBLOCK_BYPASS] = "Email Roadblock Bypass",
    _c[Events.EMAIL_ROADBLOCK_ABANDON] = "Email Roadblock Abandon",
    _c[Events.END_CARD_ITEM_SELECTED] = "End Card Item Selected",
    _c[Events.EVENT_END_CARD_IMPRESSION] = "End Card Impression",
    _c[Events.EXPERIMENT_VIEWED] = "Experiment Viewed",
    _c[Events.EXPOSURE] = "$exposure",
    _c[Events.FB_LINKING_COMPLETED] = "FB Profile Linked",
    _c[Events.FB_LINKING_STARTED] = "FB Profile Linking Started",
    _c[Events.FB_PASSWORD_CREATION_COMPLETED] = "FB Profile Password Created",
    _c[Events.FB_PASSWORD_CREATION_STARTED] = "FB Profile Password Creation Started",
    _c[Events.FB_SIGN_IN_COMPLETED] = "FB Profile Signed In",
    _c[Events.FB_SIGN_IN_STARTED] = "FB Profile Sign In Started",
    _c[Events.FB_SIGN_UP_COMPLETED] = "FB Profile Signed Up",
    _c[Events.FB_SIGN_UP_STARTED] = "FB Profile Sign Up Started",
    _c[Events.FIND_SECTION_SEARCH] = "Find Section Search",
    _c[Events.FOOTER_LINK_CLICKED] = "Footer Link Clicked",
    _c[Events.GLOBAL_NAV_CLICKED] = "Global Nav Clicked",
    _c[Events.HEADER_LINK_CLICKED] = "Header Link Clicked",
    _c[Events.HERO_ITEM_SELECT_ACTION] = "Hero Item Select Action",
    _c[Events.IDLE_PROMPT] = "Idle Prompt",
    _c[Events.IDLE_PROMPT_ACTION] = "Idle Prompt Action",
    _c[Events.LIVE_TV_BUTTON_ACTION] = "Live TV Button Action",
    _c[Events.LIVE_TV_EPG_CELL_TAPPED] = "Live TV EPG Cell Tapped",
    _c[Events.LIVE_TV_EPG_DETAIL_EXPAND] = "Live TV EPG Detail Expand",
    _c[Events.LOCAL_SECTION_LANDING] = "Local Section Landing",
    _c[Events.MENU_ITEM_SELECTED] = "Menu Item Selected",
    _c[Events.MODAL_CLOSED] = "Modal Closed",
    _c[Events.PLAYER_LANDING] = "Player Landing",
    _c[Events.PLAYLIST_BUTTON_ACTION] = "Playlist Button Action",
    _c[Events.PREVIEW_PASS_EXPIRED] = "Preview Pass Expired",
    _c[Events.PRIVACY_POLICY_PAGE_VIEW] = "Privacy Policy Viewed",
    _c[Events.PRIVIEW_PASS_STARTED] = "Preview Pass Started",
    _c[Events.PROFILE_APPLE_ID_LINK_COMPLETED] = "Profile Apple Id Link Completed",
    _c[Events.PROFILE_APPLE_ID_LINK_STARTED] = "Profile Apple Id Link Started",
    _c[Events.PROFILE_APPLE_ID_SIGNUP_COMPLETED] = "Profile Apple Id Sign Up Completed",
    _c[Events.PROFILE_APPLE_ID_SIGNUP_STARTED] = "Profile Apple Id Sign Up Started",
    _c[Events.PROFILE_GOOGLE_LINK_COMPLETED] = "Profile Google Link Completed",
    _c[Events.PROFILE_GOOGLE_LINK_STARTED] = "Profile Google Link Started",
    _c[Events.PROFILE_INITIATED] = "Profile Initiated",
    _c[Events.PROFILE_LOGGED_OUT] = "Profile Logged Out",
    _c[Events.PROFILE_PROMPT] = "Profile Prompt",
    _c[Events.PROFILE_PROMPT_LANDING] = "Profile Prompt Landing",
    _c[Events.PROFILE_SCREEN_BACKED_OUT] = "Profile Screen Backed Out",
    _c[Events.PROFILE_SIGNIN_COMPLETED] = "Profile Sign In Completed",
    _c[Events.PROFILE_SIGNUP_COMPLETED] = "Profile Sign Up Completed",
    _c[Events.PROFILE_SIGNUP_STATRED] = "Profile Sign Up Started",
    _c[Events.PROFILE_SIGN_IN_ERROR] = "Profile Sign In Error",
    _c[Events.PROFILE_SIGN_IN_FORGOT_PASSWORD] = "Profile Sign In Forgot Password",
    _c[Events.PROFILE_SIGN_IN_LANDING] = "Profile Sign In Landing",
    _c[Events.PROFILE_SIGN_IN_STARTED] = "Profile Sign In Started",
    _c[Events.PROFILE_SIGN_OUT] = "Profile Signed Out",
    _c[Events.PROFILE_SIGN_OUT_STARTED] = "Profile Sign Out Started",
    _c[Events.PROFILE_SIGN_UP_ERROR] = "Profile Sign Up Error",
    _c[Events.PROFILE_SIGN_UP_LANDING] = "Profile Sign Up Landing",
    _c[Events.PROFILE_UPSELL_PRESENTED] = "Profile Upsell Presented",
    _c[Events.PURCHASE_CTA_CLICKED] = "Purchase CTA Clicked",
    _c[Events.REMOVED_FAVORITES] = "Removed Favorites",
    _c[Events.ROADBLOCK_LANDING] = "Roadblock Landing",
    _c[Events.SEARCH_APPLIED_FILTER] = "Search Applied Filter",
    _c[Events.SEARCH_COMPLETED] = "Search Completed",
    _c[Events.SEARCH_RESULT_SELECTED] = "Search Result Selected",
    _c[Events.SEARCH_STARTED] = "Search Started",
    _c[Events.SETTINGS_SECTION_LANDING] = "Settings Section Landing",
    _c[Events.SHOP_NOW_BUTTON_CLICKED] = "Shop Now Button Clicked",
    _c[Events.TOP_LEVEL_SECTION_LANDING] = "Top Level Section Landing",
    _c[Events.UPGRADE_NOW_BUTTON_CLICKED] = "Upgrade Now Button Clicked",
    _c);
// TODO: add logic that can build these strings for
// both Segment and Tealium from a generic set of strings
export var TealiumEventStrings = (_d = {},
    _d[Events.BROWSE_ITEM_SELECTED] = "browse_item_selected",
    _d[Events.BUTTON_LINK_SELECTED] = "button_link_selected",
    _d[Events.EMAIL_ROADBLOCK_IMPRESSION] = "email_roadblock_impression",
    _d[Events.EMAIL_ROADBLOCK_SUBMIT] = "email_roadblock_submit",
    _d[Events.EMAIL_ROADBLOCK_BYPASS] = "email_roadblock_bypass",
    _d[Events.EMAIL_ROADBLOCK_ABANDON] = "email_roadblock_abandon",
    _d[Events.END_CARD_ITEM_SELECTED] = "end_card_item_selected",
    _d[Events.EVENT_END_CARD_IMPRESSION] = "end_card_impression",
    _d[Events.HEADER_LINK_CLICKED] = "header_link_click",
    _d[Events.SEARCH_APPLIED_FILTER] = "search_applied_filter",
    _d[Events.SEARCH_RESULT_SELECTED] = "search_result_selected",
    _d[Events.SEARCH_STARTED] = "search_started",
    _d[Events.SEARCH_COMPLETED] = "search_completed",
    _d[Events.PROFILE_APPLE_ID_LINK_STARTED] = "profile_apple_id_link_start",
    _d[Events.PROFILE_APPLE_ID_LINK_COMPLETED] = "profile_apple_id_link_complete",
    _d[Events.PROFILE_APPLE_ID_SIGNUP_STARTED] = "profile_apple_id_sign_up_start",
    _d[Events.PROFILE_APPLE_ID_SIGNUP_COMPLETED] = "profile_apple_id_sign_up_complete",
    _d[Events.PROFILE_GOOGLE_LINK_STARTED] = "google_link_start",
    _d[Events.PROFILE_GOOGLE_LINK_COMPLETED] = "google_link_complete",
    _d[Events.PROFILE_SIGNUP_COMPLETED] = "profile_signup_complete",
    _d[Events.PROFILE_SIGNIN_COMPLETED] = "profile_login_complete",
    _d);
/* miscellaneous */
export var APP_VERSION = "web";
export var FAVORITES_TYPE_PERSONALITY = "Category";
export var NATION = "foxnation";
export var PAGE_NAME_PREFIX = "delta:web";
export var LABEL_COLLECTION_CTA_PAGE_VIEW = "Collections Section";
export var LABEL_LIVE_LOC_REQ_PAGE_VIEW = "Live TV - Location Required";
export var LABEL_PAGE_NAME_MOVIES = "Movies Section";
export var LABEL_TV_PROVIDER_SIGN_OUT_PAGE_VIEW = "TV Provider Sign Out";
export var LOGGED_IN = "logged in";
export var LOGGED_OUT = "logged out";
export var MAX_REFERRER_LENGTH = 2;
export var OPTIMIZELY_COLLECTION_VIEWED = "Collection Viewed";
export var OPTIMIZELY_COLLECTION_VIEWED_SESSION_STORAGE = "COLLECTIONS_VIEWED";
export var OPTIMIZELY_SEGMENT_LOCAL_STORAGE = "optimizelyExperiments";
export var PAGE_PROPS_STORAGE = "PAGE_PROPS_STORAGE";
export var SEARCH_INPUT_TRIGGER_INTERVAL_MS = 5000;
export var SECOND_SCREEN_ANONYMOUS_ID = "lastAnonymousProfileId";
export var SECOND_SCREEN_PROFILE_ID = "secondScreenProfileId";
export var SEGMENT_CATEGORY_TYPE_LOCAL = "ftsLocal";
export var SEGMENT_CONTENT_PLAYING_INTERVAL_SEC = 10;
export var SEGMENT_DEVICE_ID_COOKIE = "segment-device-id";
export var SEGMENT_HERO_COLLECTION_TITLE = "showcase";
export var SEGMENT_PAGE_TYPE_CCPA = "ccpa";
export var SEGMENT_PAGE_TYPE_PLAYER = "player";
export var SESSION_STORAGE_REFERRER_TRACKING = "referrerTracking";
// todo: deprecate in favor of TealiumEventPrefixes
export var TEALIUM_EVENT_PREFIX = "analytics_ev_";
export var FP_NEVER_ATTEMPTED = "never attempted";
